export default {"src":"/_next/static/image/public/images/icons3/2.6ecc4b4b12ddd5ad213f3613b8ba255b.svg","height":72,"width":72};